export async function getVideoCover(videoSrc, format = 'webp') {
  return new Promise((resolve, reject) => {
    try {
      const video = document.createElement('video');
      video.src = videoSrc;
      video.preload = 'metadata';
      video.crossOrigin = 'anonymous';
      video.addEventListener('canplay', () =>
        resolve(transferToCanvas(video, format))
      );
      video.load();
    } catch (error) {
      reject(error);
    }
  });
}

function transferToCanvas(video, format = 'webp') {
  const canvas = document.createElement('canvas');
  //console.log(canvas, video);
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext('2d', { preserveDrawingBuffer: true });
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL(`image/${format}`);
}
